interface LogoProps {
  className?: string
  showText?: boolean
  collapsed?: boolean
  size?: 'small' | 'medium' | 'large'
  layout?: 'row' | 'col'
}

export const SamarthLogo = ({
  className = '',
  showText = true,
  collapsed = false,
  size = 'medium',
  layout = 'row',
}: LogoProps) => {
  const sizeClasses = {
    small: 'h-10 w-10',
    medium: 'h-16 w-16 md:h-20 md:w-20',
    large: 'h-24 w-24 md:h-36 md:w-36',
  }

  const textClasses = {
    small: 'text-lg',
    medium: 'text-xl md:text-2xl',
    large: 'text-2xl md:text-4xl',
  }

  const layoutClasses = layout === 'col' ? 'flex-col text-center items-center' : 'flex-row items-center'

  return (
    <div className={`flex gap-3 ${layoutClasses} ${className}`}>
      {/* User Uploaded Logo Image */}
      <div className={`flex items-center justify-center flex-shrink-0 ${sizeClasses[size]}`}>
        <img src="/logos/logo.png" alt="Sanjeevani Setu Logo" className="h-full w-full object-contain rounded-btn" />
      </div>

      {/* Brand Text: Supports dark/light mode */}
      {showText && !collapsed && (
        <div className="flex flex-col select-none justify-center">
          <span
            className={`font-bold tracking-wider leading-none text-[#1b5e20] dark:text-[#f5a623] transition-colors duration-200 ${textClasses[size]}`}
          >
            SANJEEVANI SETU
          </span>
        </div>
      )}
    </div>
  )
}
